import Grid from "@material-ui/core/Grid";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import * as React from "react";
import { FC } from "react";
import { useHistory } from "react-router";
import { useGetMyTasksQuery } from "../../api/rtk/MeApi";
import { SwissGermanLocale, SwissTimeZone } from "../../data/constants";
import { PersonTaskIndex } from "../../model/PersonTaskIndex";
import { TaskStateTranslationKey } from "../../model/TaskState";
import { TaskTypeTranslationKey } from "../../model/TaskType";
import { navigateTo } from "../../utils/Navigation";
import { ColumnDefinition, CustomGrid } from "../common/customGrid/CustomGrid";
import TranslatedMessage from "../translations/TranslatedMessage";

const MyTasks: FC = () => {
  const history = useHistory();

  const { data: tasks, isFetching: isTasksFetching } = useGetMyTasksQuery(undefined);
  const isLoading = isTasksFetching;

  if (!isLoading && tasks === undefined) {
    return <></>;
  }

  const getRowKey = (row: PersonTaskIndex) => row.id;

  const columnDefinitions: ColumnDefinition<PersonTaskIndex>[] = [
    {
      columnKey: "type",
      columnLabel: <TranslatedMessage id="task.type" />,
      cellValue: (t) => <TranslatedMessage id={TaskTypeTranslationKey[t.type]} />,
    },
    {
      columnKey: "state",
      columnLabel: <TranslatedMessage id="task.state" />,
      cellValue: (t) => <TranslatedMessage id={TaskStateTranslationKey[t.state]} />,
    },
    {
      columnKey: "deadline",
      columnLabel: <TranslatedMessage id="task.deadline" />,
      orderValue: (t) => new Date(t.deadline),
      cellValue: (t) => new Date(t.deadline).toLocaleDateString(SwissGermanLocale, { timeZone: SwissTimeZone }),
    },
  ];

  const gridContent =
    tasks !== undefined && tasks.length > 0 ? (
      <CustomGrid<PersonTaskIndex>
        hideAddButton={true}
        rows={tasks}
        columnDefinitions={columnDefinitions}
        rowKey={getRowKey}
        tableProps={{ padding: "default" }}
        addButtonTooltip="Add"
        onAddClick={() => {}}
        onRowClick={(task) => {
          const url =
            task.relativeUrl.indexOf(task.id) < 0 ? task.relativeUrl + `?taskId=${task.id}` : task.relativeUrl;
          navigateTo(url, history);
        }}
      />
    ) : (
      <Typography>
        <TranslatedMessage id="task.noInfo" />
      </Typography>
    );

  return (
    <Grid container={true} spacing={8}>
      <Grid item={true} xs={12}>
        {isLoading && <LinearProgress variant="query" />}
        {!isLoading && gridContent}
      </Grid>
    </Grid>
  );
};

export default MyTasks;
